// extracted by mini-css-extract-plugin
export default {"toast":"styles_toast__HHTdy","right":"styles_right__fJshh"};